import { sendToApi } from 'api/client'
import { Portal } from 'types'

export type PortalServiceType = 'portal' | 'page' | 'section' | 'section_item'
export type WorkspacePortalData = { workspace_portal: Portal }

export const WorkspacePortalClient = {
  getPortal: async (workspaceKey: string) => {
    return sendToApi<WorkspacePortalData>(`/w/${workspaceKey}/portal`)
  },

  forceGetPortal: async (workspaceKey: string) => {
    return sendToApi<WorkspacePortalData>(`/w/${workspaceKey}/portal?force=true`)
  },

  createPortal: async (workspacekey: string, type: PortalServiceType, data?: {}) => {
    return sendToApi<WorkspacePortalData>(`/w/${workspacekey}/portal`, { method: 'POST', body: { type, data } })
  },

  updatePortal: async (workspaceKey: string, type: PortalServiceType, data?: {}) => {
    return sendToApi<WorkspacePortalData>(`/w/${workspaceKey}/portal`, { method: 'PUT', body: { type, data } })
  },

  destroyPortal: async (workspacekey: string, type: PortalServiceType, data?: {}) => {
    return sendToApi<WorkspacePortalData>(`/w/${workspacekey}/portal`, { method: 'DELETE', body: { type, data } })
  },
}
